'use strict';

define('vb/private/services/readers/openApiObjectFactory',[
  'urijs/URI',
  'vb/private/utils',
  'vb/private/services/readers/openApi2Object',
  'vb/private/services/readers/openApi3Object',
], (
  URI,
  Utils,
  OpenApi2Object,
  OpenApi3Object,
) => {
  /**
   * @typedef {import('vb/private/services/services').default} Services
   */

  const normalizePath = (path) => {
    let url = path;
    if (!path.startsWith('text!')) {
      // See UrlMapper.normalizeUrl()
      // remove 'dots' in the middle of the path
      // remove default ports
      const uri = URI(path).hash('').normalizePort().normalizePath();
      url = uri.toString();
    }
    return url;
  };

  /**
   * Creates a callback function that can be used to load service metadata documents.
   * By default it delegates the call to the Services. If Services are not available
   * in the context, it loads service metadata documents by directly calling
   * RuntimeEnvironment.
   *
   * @param {Object} context
   * @param {Object} [context.initParams]
   * @param {String} [context.definitionUrl]
   * @param {Services} [context.services]
   * @returns {(string) => Promise<Object>}
   */
  // eslint-disable-next-line no-unused-vars
  const createLoaderFunc = ({ initParams = {}, definitionUrl, services }) => {
    if (services) {
      // TODO: support relative references:
      // https://swagger.io/specification/#relative-references-u-r-i
      // "relative references are resolved using the URLs defined in the Server Object as a Base URL."
      return (path) => services.fetchServiceDefinitionInfo(path, initParams).then((info) => info.data);
    }

    // fallback: loader function without caching by Services
    const loaderFunc = (path) => Utils.getRuntimeEnvironment()
      .then((env) => {
        const url = normalizePath(path);
        return env.getServiceDefinitionInfo(url, initParams).then((info) => info.data);
      });
    return loaderFunc;
  };

  /**
   *
   */
  class OpenApiObjectFactory {
    /**
     * return a model for the definition
     * @param definition the JSON object
     * @param context abstraction of Application context. optional, used for variables substitution.
     *        One of the used properties for context is 'definitionUrl' whose value should be the
     *        url (or path) from which the definition was obtained.
     * @returns {OpenApi3Object|OpenApi2Object}
     */
    static get(definition, context) {
      const ctxt = context ? Object.assign({}, context) : {};

      ctxt.serviceMetadataLoader = createLoaderFunc(ctxt);

      if (definition.openapi) {
        return new OpenApi3Object(definition, ctxt);
      }
      return new OpenApi2Object(definition, ctxt);
    }
  }

  return OpenApiObjectFactory;
});

